import { Injectable } from '@angular/core';
import { BffCommunicationService } from '../../../../core/services/_index';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../../../app-config.service';
import { CapaciteModel } from '../../modeles/capacite.model';

@Injectable({
  providedIn: 'root'
})
export class CapaciteApiService {
  constructor(private readonly bffApi: BffCommunicationService, private readonly appConfigService: AppConfigService) {}

  private getBaseApiUrl() {
    const idProjet = this.appConfigService.idProjet;
    return `/api/v1/projets/${idProjet}`;
  }

  private getApiUrl() {
    return `${this.getBaseApiUrl()}/capacites`;
  }

  getCapacite(): Observable<CapaciteModel[]> {
    return this.bffApi.getJSONBFF(this.getApiUrl()) as Observable<CapaciteModel[]>;
  }

  updateCapacite(capacite: CapaciteModel): Observable<any> {
    return this.bffApi.putJSONBFF(`${this.getApiUrl()}/${capacite.id}`, capacite);
  }

  calculResultat(capacite: CapaciteModel): Observable<any> {
    return this.bffApi.putJSONBFF(`${this.getApiUrl()}/${capacite.id}/calculer`, capacite);
  }

  simulerResultat(capacite: CapaciteModel): Observable<CapaciteModel> {
    return this.bffApi.postJSONBFF(`${this.getBaseApiUrl()}/capacitescalculer`, capacite) as Observable<CapaciteModel>;
  }
}
